import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filenameTrim' })
export class FileNameTrimPipe implements PipeTransform {
	transform(value: string): any {
		return value.split('/').pop();
	}
}
